module.exports = __webpack_public_path__ + "img/10.079f266a.png";